var PropTypes = require('prop-types');
let React = require('react');

class Notification extends React.Component {
  static defaultProps = {
    message: '',
    icon: 'bl-attention',
    timeout: 0,
    debugMode: false,
    defaultTitle: 'Internal Error',
    defaultMessage: 'Please contact your system administator if this happens again.',
  };

  static propTypes = {
    index: PropTypes.number.isRequired,
    handleClose: PropTypes.func,
    timeout: PropTypes.number,
    debugMode: PropTypes.bool,
    message: PropTypes.any,
    // If debug is false, the default message will be displayed
    defaultMessage: PropTypes.string,
    icon: PropTypes.string,
    extraClasses: PropTypes.string,
  };

  componentDidMount() {
    this.timeoutFunction = null;
    if (this.props.timeout !== 0) {
      this.timeoutFunction = setTimeout(this.props.handleClose, this.props.timeout);
    }
  }

  handleClose = () => {
    clearTimeout(this.timeoutFunction);
    this.props.handleClose(this.props.index);
  };

  render() {
    let iconClass = `bl ${this.props.icon} fa-lg`;

    return (
      <div className={'alert alert-dismissible ' + this.props.extraClasses}>
        <div className='container'>
          <button type='button' className='close' style={{minWidth: '10%'}} onClick={this.handleClose}>
            <span className='bl bl-x'/>
          </button>
          <div className="text-indent">
            <span className={iconClass}/> &nbsp;
            <strong>{this.props.debugMode ? this.props.message : this.props.defaultMessage}</strong>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = Notification;
